import { Yup } from 'cng-web-lib'
import Namespace from 'src/constants/locale/Namespace'
import {
  constants,
} from 'cng-web-lib'

const {
  locale: {
    key: {
      CommonValidationMessageKeys,
    },
  },
} = constants

function makeValidationSchema(translate) {
  let requiredMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    CommonValidationMessageKeys.REQUIRED
  )
  let dateTypeErrorMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    CommonValidationMessageKeys.DATE_TYPE_ERROR
  )

  return Yup.object({
    voyageLegId: Yup.number(),
    createdBy: Yup.number(),
    createdDate: Yup.date().validFormat().typeError(dateTypeErrorMessage),
    updatedBy: Yup.number(),
    updatedDate: Yup.date().validFormat().typeError(dateTypeErrorMessage),
    version: Yup.number(),
    arrivalTime: Yup.date().validFormat().typeError(dateTypeErrorMessage),
    departureTime: Yup.date().validFormat().typeError(dateTypeErrorMessage),
    portCode: Yup.string(),
    seqNo: Yup.number(),
    partyId: Yup.number(),
    terminalCode: Yup.string(),
    transportMode: Yup.string(),
    schVesselName: Yup.string(),
    schVoyageNo: Yup.string(),
    schService: Yup.string(),
    transitTime: Yup.number(),
    source: Yup.string(),
    cyCutoffTime: Yup.number(),
  })
}

export default makeValidationSchema
